<template>
  <div class="qrcode-operate-dialog">
    <el-dialog
      top="5vh"
      class="dialog-full-medium"
      width="50%"
      :title="title"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      @open="handleOpen"
      append-to-body
      custom-class="set-dialog__body"
    >
      <div class="dialog__body">
        <el-form
          size="small"
          ref="ruleForm"
        >
          <el-form-item label="订单编号：">{{paymentObj.paymentNo}}</el-form-item>
          <el-form-item label="付款金额：">{{paymentObj.payAmount | toFenThousandsAndFloat}} 元</el-form-item>
          <el-form-item label="收款对象：" class="account-name">
            <el-row class="content" v-if="isModify">
              <el-col :span="16">
                <el-input v-model="accountName" :size="formSize" placeholder="请输入"></el-input>
              </el-col>
              <el-col :span="8">
                <el-button type="text" @click="handleModify">保存</el-button>
                <el-button v-if="isModify" type="text" @click="handleCancelModify">取消</el-button>
              </el-col>
            </el-row>
            <el-row class="content" v-else>
              <span>{{accountName || '-'}}</span>
              <el-button type="text" @click="handleModify">修改</el-button>
            </el-row>
          </el-form-item>
          <el-form-item label="收款码牌：">
            <div v-if="!qrCodeUrl" class="no-certificate">无</div>
            <jr-preview-image v-else :image-list="$stringToArray(qrCodeUrl)|| []" :is-own="true" />
          </el-form-item>
        </el-form>
        <!-- 支付截图元素 -->
        <div id="payment-results" class="payment-results">
          <div class="h-bg">
            <div class="time">
              <div>{{payData.time}}</div>
              <img src="../../../../../assets/image/op-icon.png" />
            </div>
            <div class="logo">
              <img src="../../../../../assets/image/alipay.png" />
              <div class="finish">完成</div>
            </div>
            <div class="message">转账成功</div>
            <div class="money">
              <span>¥</span><span class="num">{{payData.num}}</span>
            </div>
            <div class="pay-list">
              <div class="flex-box pay-message">
                <div>收款方</div>
                <div>{{payData.name}}</div>
              </div>
              <div class="flex-box">
                <div>付款方式</div>
                <div>账户余额</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="$has('FWS-SFKGL-FKD-FKTJ')">
          <el-button @click="handleClose()" :size="formSize">取消</el-button>
          <el-button
            type="primary"
            :size="formSize"
            @click="submit()"
            :loading="submitLoading"
            :disabled="isModify"
          >
            确认付款
          </el-button>
        </template>
        <el-button v-else @click="handleClose()" :size="formSize">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { htmlToImg } from '@/utils/htmlToImg';
import { uploadFile } from '@/api/global';
import { getAccount } from '@/utils/account';
import { formatTime, toFenThousandsAndFloat } from '@/filters';
import { setPaymentPaymentOffline, modifyAccountName, queryPaymentDetail } from '@/api/receivables';
import { checkVersion } from '@/utils/versionUpdate';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: '发起付款',
    },
    paymentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      submitLoading: false,
      nameCache: '',
      accountName: '',
      isModify: false,
      payData: {
        time: '',
        num: '',
        name: '',
      },
      qrCodeUrl: '', // 收款二维码地址(码牌)
    };
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.qrCodeUrl = '';
        this.submitLoading = false;
        this.payData = {
          time: '',
          num: '',
          name: '',
        };
        this.init();
      });
    },
    async init() {
      try {
        const res = await queryPaymentDetail({ paymentNo: this.paymentObj.paymentNo });
        const { accountName, qrCodeUrl } = res.data;
        this.accountName = accountName;
        this.nameCache = accountName;
        this.qrCodeUrl = qrCodeUrl || '';
      } catch (error) {
        console.log(error);
      }
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
    },
    // 提交
    async submit() {
      const flag = await checkVersion();
      if (flag) {
        this.$alert(
          '新版本已就绪，请刷新重试！',
          {
            showClose: false,
          },
        ).then(() => {
          window.location.reload();
        });
        return;
      }
      this.payData = {
        time: formatTime(Date.now(), 'HH:mm'),
        num: toFenThousandsAndFloat(this.paymentObj.payAmount),
        name: this.accountName,
      };
      this.$nextTick(async () => {
        try {
          this.submitLoading = true;
          const file = await htmlToImg('payment-results');
          const form = new FormData();
          form.append('file', file, `${Date.now()}.png`); // 文件
          form.append('serverType', 4); // 业务线
          form.append('path', 'finance-manager/'); // 存储目录
          form.append('operatorName', getAccount().userName); // 操作人
          const res = await uploadFile(form);
          const { path } = res.data;
          this.handleOffline(path);
        } catch (error) {
          console.log(error);
          this.submitLoading = false;
        }
      });
    },
    // 线下支付
    handleOffline(path) {
      const params = {
        pic: path, // 付款图片
        paymentNo: this.paymentObj.paymentNo, // 付款单号
      };
      // 付款单列表-发起付款
      setPaymentPaymentOffline(params).then(() => {
        this.$message.success('操作成功！');
        this.handleClose();
        this.$emit('success');
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    async handleModify() {
      this.isModify = !this.isModify;
      if (!this.isModify) {
        try {
          await modifyAccountName({
            paymentNo: this.paymentObj.paymentNo,
            accountName: this.accountName,
          });
          if (this.isModify) {
            this.nameCache = this.accountName;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    handleCancelModify() {
      this.isModify = false;
      this.accountName = this.nameCache;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 400px;
    .el-dialog__body {
      overflow-x: hidden;
    }
  }
  .el-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .account-name {
    .el-form-item__content {
      flex: 1;
    }
  }
  .image-item {
    width: 250px;
    height: 250px;
  }
}
.content {
  display: flex;
  align-items: center;
  ::v-deep {
    .el-button {
      min-width: auto;
    }
  }
}

.payment-results {
  width: 375px;
  height: 812px;
  background: #fff;
  position: fixed;
  top: 0;
  left: -9999px;
  z-index: 20000;
  color: #fff;
  .h-bg {
    width: 100%;
    height: 319px;
    background: url("../../../../../assets/image/alipay-bg.png") no-repeat;
    background-size: 100%;
    overflow: hidden;
    .time {
      font-size: 15px;
      line-height: 21px;
      font-family: "Regular";
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 34.5px;
      img {
        height: 44px;
      }
    }
    .message {
      text-align: center;
      font-size: 14px;
      font-family: "Regular";
      font-weight: 400;
      color: #fff;
      line-height: 21px;
    }
    .logo {
      padding: 10px 0 8px 0;
      position: relative;
      display: flex;
      justify-content: center;
      img {
        width: 26px;
        height: 26px;
      }
      .finish {
        position: absolute;
        right: 15px;
        top: 4px;
        font-size: 14px;
        font-family: "Regular";
        font-weight: 400;
        color: #fff;
        line-height: 20px;
      }
    }
    .money {
      text-align: center;
      font-size: 0;
      font-family: "Regular";
      font-weight: 400;
      color: #fff;
      line-height: 45px;
      margin-top: 8px;
      span {
        display: inline-block;
        font-size: 32px;
      }
      .num {
        font-size: 44px;
        font-family: DINAlternate-Bold, DINAlternate;
        // font-weight: bold;
        color: #fff;
        line-height: 51.5px;
        margin-left: 5px;
      }
    }
    .pay-list {
      margin-top: 19px;
      padding: 0 15px 0 16px;
      .flex-box {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-family: "Regular";
        font-weight: 400;
        color: #fff;
        line-height: 21px;
      }
      .pay-message {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;
        line-height: 21px;
        margin-bottom: 2.5px;
      }
    }
  }
}
</style>
